import { render, staticRenderFns } from "./List.vue?vue&type=template&id=24a7f3da&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=24a7f3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a7f3da",
  null
  
)

export default component.exports